import { render, staticRenderFns } from "./PhoneElement.vue?vue&type=template&id=39e3c6ad&"
import script from "./PhoneElement.vue?vue&type=script&lang=js&"
export * from "./PhoneElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports